import { render, staticRenderFns } from "./CreateDataForm.vue?vue&type=template&id=11149cd1"
import script from "./CreateDataForm.vue?vue&type=script&lang=js"
export * from "./CreateDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports